import { FunctionComponent } from 'react';

import _ from 'lodash';

import { Typography } from 'omakase';
import { core } from '@tock/coretypes';
import ProfileImportantDates from 'components/profile/ProfileImportantDates';
import ProfilePreferencesLists from 'components/profile/ProfilePreferencesLists';
import ProfileSection from 'components/profile/ProfileSection';

interface OwnProps {
  patronProfile: core.PatronProfile;
  importantDates: core.IPatronProfileDay[];
  isLoading: boolean;
}

const ProfileDinerSection = ({ patronProfile, importantDates, isLoading }: OwnProps) => {
  const hasImportantDates = patronProfile.day.length > 0;
  const hasPreferences =
    !_.isEmpty(patronProfile.patronCuisineIds) ||
    !_.isEmpty(patronProfile.patronAversions) ||
    !_.isEmpty(patronProfile.patronDietaryRestrictionIds) ||
    !_.isEmpty(patronProfile.patronHospitalityPreferenceIds);

  if (!isLoading && !hasImportantDates && !hasPreferences) {
    return null;
  }

  return (
    <ProfileSection name={<YourDinerProfile />} isLoading={isLoading}>
      {hasImportantDates && (
        <div className="Profile-dinerSubsection">
          <ProfileImportantDates importantDates={importantDates} />
        </div>
      )}
      {hasPreferences && (
        <div className="Profile-dinerSubsection">
          <ProfilePreferencesLists patronProfile={patronProfile} />
        </div>
      )}
    </ProfileSection>
  );
};

const YourDinerProfile: FunctionComponent<{}> = () => {
  return (
    <>
      <Typography component="h2" variant="heading02" mb={1}>
        Your diner profile
      </Typography>
      <Typography variant="body02">
        Information you provide here will be visible to the restaurants you book.
      </Typography>
    </>
  );
};

export default ProfileDinerSection;
